import { Player } from '@lottiefiles/react-lottie-player';
import { CSSProperties, memo } from 'react';

interface LottiePlayerProps {
  autoplay?: boolean;
  loop?: boolean;
  src: string;
  onEvent?: (event: string) => void;
  width?: string | number;
  height?: string | number;
  renderer?: string;
  style?: CSSProperties;
}

/**
 * Used to go and stop animation for non autoplay render
 */
const AUTO_PLAY_FRAME = 30;

export const LottiePlayer = memo(
  ({
    src = '',
    loop = true,
    autoplay = true,
    onEvent = () => {},
    width = 150,
    height = 150,
    renderer = 'svg',
    style,
  }: LottiePlayerProps) => {
    return (
      <Player
        lottieRef={(lottieRef) => {
          if (!autoplay) {
            // this prevents showing an empty state when the autoplay is off
            // used on export and thumbnail, it may get a random frame, but there is no way to know each frame for each animation it will show
            lottieRef.goToAndStop(AUTO_PLAY_FRAME, true);
          }
        }}
        autoplay={autoplay}
        loop={loop}
        controls={false}
        src={src}
        // adding key to re-render canvas for thumbnails
        key={src}
        style={{ height, width, ...style }}
        onEvent={onEvent}
        renderer={renderer}
      />
    );
  },
);
LottiePlayer.displayName = 'LottiePlayer';
